export const brochureApplyDetailAction= (data) => { 
    return {
       type: data.type,
       data: data.data
    }
 }